<template>
  <v-card
    class="card-border my-3"
    data-testid="home-skeleton-predictedFinancialImpacts"
    outlined
  >
    <div class="px-3 py-3">
      <div class="d-flex align-center justify-space-between mb-1">
        <v-skeleton-loader max-width="100" type="text" />
        <v-skeleton-loader max-width="60" type="text" />
      </div>
      <v-skeleton-loader max-width="180" type="text" />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'PotentialFinancialImpactsSkeleton',
}
</script>
